import _ from 'underscore';
import { BaseAccountsSchemaProcessor } from './base-accounts-schema-processor';

export class AccountImportSchemaProcessor extends BaseAccountsSchemaProcessor {
  constructor(options) {
    const propWhitelist = _.compact([
      'Name',
      'LastImportInfo/ImportName',
      'LastImportInfo/EntityIdsSpecified',
    ]);

    super(options, { propWhitelist });
  }

  getOverridenSchemaProperties() {
    return {
      LastImportInfoEntityIdsSpecified: {
        chooseType: 'radio-boolean',
        operators: ['eq'],
      },
    };
  }
}
